import React from "react";

import FaqHomeCard from "../../components/Card/FaqHomeCard";

function HomeCardsSection({
  triplets,
  faqs,
  verticals,
  faqSelection,
  vmtSelection,
  setNavigationStatus,
  setScrollToObject,
}) {
  faqs.sort((a, b) => b._source.views - a._source.views);

  const showSection = (index, vertical) => {
    let top3 = faqs
      .filter(function (el) {
        if (el._source.vertical) {
          return el._source.vertical === vertical;
        } else return false;
      })
      .slice(0, 3);
    return (
      <FaqHomeCard
        vertical={vertical}
        top3Questions={top3}
        triplets={triplets}
        faqSelection={faqSelection}
        vmtSelection={vmtSelection}
        setNavigationStatus={setNavigationStatus}
        setScrollToObject={setScrollToObject}
      />
    );
  };

  return (
    <div className="flex pt-12 flex-wrap" style={{ margin: "-1%" }}>
      {Object.entries(verticals).map(([k, i]) => showSection(k, i))}
    </div>
  );
}

export default HomeCardsSection;
